import React from 'react';
import { Icon, Typography } from 'gd-design-library';
import NoImagePlaceholder from '@assets/images/no-image-placeholder.png';

import styles from './SubscribedMembershipCard.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);
const CN = 'subscribed-membership-card';
const imageClassName = `${CN}__image`;
const infoClassName = `${CN}__info`;
const checkIconClassName = `${CN}__icon--check`;
const featureClassName = `${CN}__feature`;
const unsubscribeButtonClassName = `${CN}__button--unsubscribe`;
const middilePartClassName = `${CN}__middle-part`;
const dateClassName = `${CN}__date`;

interface SubscribedMembershipCardProps {
    key: string;
    name: string;
    features: string[];
    image?: string;
    handleUnsubscribe: () => unknown;
    startDate: Date;
    duration: string;
}

export const SubscribedMembershipCard:React.FC<SubscribedMembershipCardProps> = ({
  key,
  name,
  features,
  image,
  handleUnsubscribe,
  startDate,
  duration
}) => {
  const calculateEndDay = (): Date | null => {
    let endDate : Date | null = new Date(startDate);
    if (duration === '1 Week') {
      endDate.setDate(startDate.getDate()+7);
    } else if (duration === '1 Month') {
      endDate.setMonth(startDate.getMonth()+1);
    } else if (duration === '3 Months') {
      endDate.setMonth(startDate.getMonth()+3);
    } else if (duration === '6 Months') {
      endDate.setMonth(startDate.getMonth()+6);
    } else if (duration === '1 Year') {
      endDate.setFullYear(startDate.getFullYear()+1);
    } else {
      endDate = null;
    }

    return endDate;
  };

  const endDate = calculateEndDay();

  return <div key={ key } className={ cx(CN) }>
    <Typography
      className={ cx(dateClassName) }
      variant='h6'>
      { endDate ? `${startDate.toDateString()} - ${endDate.toDateString()}` : `Subscribed on ${startDate.toDateString()}` }
    </Typography>
    <div className={ cx(middilePartClassName) }>
      <img className={ cx(imageClassName) } src={ image ?? NoImagePlaceholder.src }/>
      <div className={ cx(infoClassName) }>
        <Typography variant='h6'>{ name }</Typography>
        { features.map(feature => <div key={ feature } className={ cx(featureClassName) }>
          <span className={ cx(checkIconClassName) }><Icon name='check'/></span>
          <Typography variant='h6'>{ feature }</Typography>
        </div>)}
      </div>
    </div>
    <Typography
      role='button'
      onClick={ handleUnsubscribe }
      className={ cx(unsubscribeButtonClassName) }
    >
      Unsubscribe
    </Typography>
  </div>;
};


